import { pickBy } from 'lodash';

const removeEmpty = (obj) => {
  const cleanObj = pickBy(obj, (value) => {
    return value !== '';
  });

  return cleanObj;
};

export default removeEmpty;
